import axios from "axios";
import loginedApi from "../apis";
import moment from "moment";

export const UploadFileToServer =
  ({ file, appointmentId, source,type }) =>
  async (dispatch) => {
    let formData = new FormData();
    formData.append("name", file.name);
    formData.append("file", file);
    formData.append("appintmentId", appointmentId);
    formData.append("source", source ? source : "Patient");
    formData.append("type", type ? type : "Schedule");

    try {
      let responce = await loginedApi.post("updatereports", formData, {});
      //let responce = await axios.post("https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/reportsuploads", formData, {})

      let imageName = responce.data.data.info?.split("!./FileSeperator/.!,")[0];
      console.log("imageName",imageName)
      return { imageName, data: responce?.data?.data };
    } catch (error) {}
  };

export const RemoveFileFromServer = (filename) => async (dispatch) => {
  try {
    const options = {
      requestType: 596,
      token: "C2MDVerificationToken",
      data: { filename: filename },
    };

    let responce = await axios.post(
      "https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/removereports",
      options
    );
    console.log(responce);
  } catch (error) {}
};
